<app-sidebar
  layoutVariant="provider"
  [menuItems]="menuItems"
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  title="Admin"
>
</app-sidebar>



